export { default } from "./SparePartList.container";
